(function(api) {
	api.InvenGenerirajStavkeInventura = InvenGenerirajStavkeInventura;
	api.InvenVratiUskladjeno = InvenVratiUskladjeno;
	api.InvenUpisiSaldoUStavkeInventure = InvenUpisiSaldoUStavkeInventure;
	api.InvenSObrisi = InvenSObrisi;
	api.InvenObrisi = InvenObrisi;
	api.InvenSPronadeno = InvenSPronadeno;
	api.InvenSZaRashod = InvenSZaRashod;
	api.InvenSBrojPronadenihZaFilter = InvenSBrojPronadenihZaFilter;
	api.InvenSPronadenoFilter = InvenSPronadenoFilter;
	api.InvenSZaduzi = InvenSZaduzi;
	api.SredByBarkod = SredByBarkod;
	api.SredByInvBroj = SredByInvBroj;
	api.OsZaduziById = OsZaduziById;
	api.SredStById = SredStById;
	api.InvensPostoji = InvensPostoji;
	api.SredById = SredById;
	api.SredStIspravakZadnjeStavkeKarticeValidate = SredStIspravakZadnjeStavkeKarticeValidate;
	api.SredStSetAfterPolje = SredStSetAfterPolje;
	api.SredStValidatePolje = SredStValidatePolje;
	api.SredStZamijeniBrojStavke = SredStZamijeniBrojStavke;
	api.SredStPreracunKartice = SredStPreracunKartice;
	api.SredStPresloziKarticu = SredStPresloziKarticu;
	api.SredStKarticaImaPreknjizenje = SredStKarticaImaPreknjizenje;
	api.SredStPromjenaKontaNaKartici = SredStPromjenaKontaNaKartici;
	api.SredStDodajUkloniSredStNaPopisnuListu = SredStDodajUkloniSredStNaPopisnuListu;
	api.SredStProvjeriIspisNaListi = SredStProvjeriIspisNaListi;
	api.SredStRekapPoKontu = SredStRekapPoKontu;
	api.SredStPromjenaPozicijaIzvoriMogucUnosValidate = SredStPromjenaPozicijaIzvoriMogucUnosValidate;
	api.SredStPreknjizenjePitanjePrijeUpisa = SredStPreknjizenjePitanjePrijeUpisa;
	api.OsobaBySred = OsobaBySred;
	api.SobaByBarkod = SobaByBarkod;
	api.IKnjigaNabDefault = IKnjigaNabDefault;
	api.IRekapKnjDefault = IRekapKnjDefault;
	api.IAktDefault = IAktDefault;
	api.ZgradaById = ZgradaById;
	api.SobaById = SobaById;
	api.SobaByOznaka = SobaByOznaka;	
	api.LokacijaById = LokacijaById;	
	api.GetOsZaduziFields = GetOsZaduziFields;
	api.GetSredStFields = GetSredStFields;
	api.TipPromById = TipPromById;
	api.TipPromObrisi = TipPromObrisi;
	api.LokacijaObrisi = LokacijaObrisi;
	api.LokacijaMoguceBrisanje = LokacijaMoguceBrisanje;
	api.ZgradaSetAfterPolje = ZgradaSetAfterPolje;
	api.ZgradaMoguceBrisanje = ZgradaMoguceBrisanje;
	api.ZgradaObrisi = ZgradaObrisi;
	api.SobaSetAfterPolje = SobaSetAfterPolje;
	api.SobaMoguceBrisanje = SobaMoguceBrisanje;
	api.SobaObrisi = SobaObrisi;
	api.OsobaSetAfterPolje = OsobaSetAfterPolje;
	api.OsobaMoguceBrisanje = OsobaMoguceBrisanje;
	api.OsobaObrisi = OsobaObrisi;
	api.AmGrupaMoguceBrisanje = AmGrupaMoguceBrisanje;
	api.AmGrupaObrisi = AmGrupaObrisi;
	api.AmGrupaSetAfterPolje = AmGrupaSetAfterPolje;
	api.AmGrupaPitanja = AmGrupaPitanja;
	api.AmGrupaPromSetAfterPolje = AmGrupaPromSetAfterPolje;
	api.OsGrupaMoguceBrisanje = OsGrupaMoguceBrisanje;
	api.OsGrupaObrisi = OsGrupaObrisi;
	api.OsKontoObrisi = OsKontoObrisi;
	api.GetAzuriranjeShemeKnjizenjaPitanja = GetAzuriranjeShemeKnjizenjaPitanja;
	api.AzuriranjeShemeKnjizenjaPremaStanjuNaKaricamaInventara = AzuriranjeShemeKnjizenjaPremaStanjuNaKaricamaInventara;
	api.GetAzurirajKarticuSvePitanje = GetAzurirajKarticuSvePitanje;
	api.GetAzurirajKarticuPitanje = GetAzurirajKarticuPitanje;
	api.OsKontoAzurirajKarticu = OsKontoAzurirajKarticu;
	api.OsKontoAzurirajKarticuSve = OsKontoAzurirajKarticuSve;
	api.OsKontoNoviIzvoriVlasnistvaUpis = OsKontoNoviIzvoriVlasnistvaUpis;
	api.OsZaduziSetAfterPolje = OsZaduziSetAfterPolje;
	api.OsOvlastenjeLoadListAfterInven = OsOvlastenjeLoadListAfterInven;
	api.SBInvBrojClick = SBInvBrojClick;
	api.PonovoIzracunajBarKod = PonovoIzracunajBarKod;
	api.SredSetAfterPolje = SredSetAfterPolje;
	api.SredSkObrisi = SredSkObrisi;	
	api.SredSetParamOsnovniPodaci = SredSetParamOsnovniPodaci;		
	api.OsOvlastenjeDeaktiviraj = OsOvlastenjeDeaktiviraj;
	api.AmortizacijaUpisi = AmortizacijaUpisi;
	api.AmortizacijaSetAfterPolje = AmortizacijaSetAfterPolje;
	api.AmortizacijaObrisi = AmortizacijaObrisi;	
	api.BrojDokumentaGKZadnji = BrojDokumentaGKZadnji;
	api.Revaloriziraj = Revaloriziraj;
	api.RashodUpisi = RashodUpisi;
	api.RashodSetAfterPolje = RashodSetAfterPolje;	
	api.RashodValidatePolje = RashodValidatePolje;
	api.ArhivaNadopuniShemu = ArhivaNadopuniShemu;
	api.RazduziZaduziSetAfterPolje = RazduziZaduziSetAfterPolje;	
	api.ArhivaZakljucaj = ArhivaZakljucaj;	
	api.ArhivaOtkljucaj = ArhivaOtkljucaj;	
	api.ArhivaObrisi = ArhivaObrisi;
	api.SredSlikaGetSlika = SredSlikaGetSlika;	
	api.SredSlikaUpload = SredSlikaUpload;
	api.SredSlikaCopy = SredSlikaCopy;
	api.SredSlikaPaste = SredSlikaPaste;
	api.SredSlikaObrisi = SredSlikaObrisi;		
	api.SredSlikaRename = SredSlikaRename;
	api.NapuniVrstePromjene = NapuniVrstePromjene;	
	api.ProvjeriDokumentZaKnjizenje = ProvjeriDokumentZaKnjizenje;
	api.CBVrPromjeneChange = CBVrPromjeneChange;
	api.GetOsZaduziMogucIspravak = GetOsZaduziMogucIspravak;	
	api.SredKopirajViseSetBarkodAfterInvBroj = SredKopirajViseSetBarkodAfterInvBroj;
	api.PostavkeMogucUnos = PostavkeMogucUnos;
	api.PostavkeProvjeriInventuru = PostavkeProvjeriInventuru;	
	api.PostavkeSetAfterPolje = PostavkeSetAfterPolje;
	api.OsGrupaShemaObrisi = OsGrupaShemaObrisi;
	api.OsGrupaGetAgPromjena = OsGrupaGetAgPromjena;
	api.OsGrupaUpisAmGrupeUSredstva = OsGrupaUpisAmGrupeUSredstva;
	api.GetZaduzenjaInventaraSFields = GetZaduzenjaInventaraSFields;
	api.InventarObrisi = InventarObrisi;
	api.InventarImportXml = InventarImportXml;
	api.InvenTrebaLiUskladitiKolSaKarticom = InvenTrebaLiUskladitiKolSaKarticom;
	api.InvenUskladiKolSaKarticom = InvenUskladiKolSaKarticom;	
	api.OsGrupaShemaDefinirana = OsGrupaShemaDefinirana;
	api.OsGrupaShemaSeMijenja = OsGrupaShemaSeMijenja;
	api.SredMogucaPodjelaKartice = SredMogucaPodjelaKartice;
	api.SredGetPitanjeZaPodjeluKartice = SredGetPitanjeZaPodjeluKartice;
	api.SredPodijeliKarticu = SredPodijeliKarticu;
	api.SredUmetniInventurneBrojeve = SredUmetniInventurneBrojeve;
	api.GetSobaZaduziFields = GetSobaZaduziFields;
	api.SredOpGetBrojSlika = SredOpGetBrojSlika;

    function ArhivaNadopuniShemu() {
        return $.dsDirectCall({ 
			method: "ArhivaNadopuniShemu" 
        });
    }	

    function GetSredStFields() {
        return $.dsDirectCall({ 
			method: "GetSredStFields"
        });
    }

    function GetOsZaduziFields() {
        return $.dsDirectCall({ 
			method: "GetOsZaduziFields" 
        });
    }

	function InvenGenerirajStavkeInventura(inven, pronadeno, zaRashod){
		return $.dsDirectCall({
			method: "InvenGenerirajStavkeInventura",
			params: [ inven, pronadeno, zaRashod ]
		});
	}
	
	function InvenVratiUskladjeno(inven){
		return $.dsDirectCall({
			method: "InvenVratiUskladjeno",
			params: [ inven ]
		});
	}
	
	function InvenUpisiSaldoUStavkeInventure(inven){
		return $.dsDirectCall({
			method: "InvenUpisiSaldoUStavkeInventure",
			params: [ inven ]
		});
	}
		
	function InvenSObrisi(invens){
		return $.dsDirectCall({
			method: "InvenSObrisi",
			params: [ invens ]
		});
	}

	function InvenObrisi(inven){
		return $.dsDirectCall({
			method: "InvenObrisi",
			params: [ inven ]
		});
	}
	
	function InvenSPronadeno(invens){
		return $.dsDirectCall({
			method: "InvenSPronadeno",
			params: [ invens ]
		});
	}
	
	function InvenSZaRashod(invens){
		return $.dsDirectCall({
			method: "InvenSZaRashod",
			params: [ invens ]
		});
	}
	
	function InvenSBrojPronadenihZaFilter(invens, osoba){
		return $.dsDirectCall({
			method: "InvenSBrojPronadenihZaFilter",
			params: [ invens, osoba ]
		});
	}
	
	function InvenSPronadenoFilter(invens, osoba){
		return $.dsDirectCall({
			method: "InvenSPronadenoFilter",
			params: [ invens, osoba ]
		});
	}
	
	function InvenSZaduzi(inven){
		return $.dsDirectCall({
			method: "InvenSZaduzi",
			params: [ inven ]
		});
	}
	
	function SredByBarkod(barkod){
		return $.dsDirectCall({
			method: "SredByBarkod",
			params: [ barkod ]
		});
	}
	
	function SredByInvBroj(invBroj, osSi){
		return $.dsDirectCall({
			method: "SredByInvBroj",
			params: [ invBroj, osSi ]
		});
	}
	
	function OsZaduziById(osZaduzi){
		return $.dsDirectCall({
			method: "OsZaduziById",
			params: [ osZaduzi ]
		});
	}
	
	function SredStById(zSredst){
		return $.dsDirectCall({
			method: "SredStById",
			params: [ zSredst ]
		});
	}
	
	function InvensPostoji(inven, sred){
		return $.dsDirectCall({
			method: "InvensPostoji",
			params: [ inven, sred ]
		});
	}
	
	function SredById(sred){
		return $.dsDirectCall({
			method: "SredById",
			params: [ sred ]
		});
	}
	
	function SredStIspravakZadnjeStavkeKarticeValidate(sredSt){
		return $.dsDirectCall({
			method: "SredStIspravakZadnjeStavkeKarticeValidate",
			params: [ sredSt ]
		});		
	}
	
	function SredStSetAfterPolje(sredSt, kojePolje, novi){
		return $.dsDirectCallPost({
			method: "SredStSetAfterPolje",
			controller: "sredSt",
			params: [ kojePolje, novi ],
			data: [ sredSt ],
			fail: function (error, textStatus, jqXHR, logicalError){				
			}
		});
	}	
	
	function SredStValidatePolje(sredSt, kojePolje, novi){		
		return $.dsDirectCallPost({
			method: "SredStValidatePolje",
			controller: "sredSt",
			params: [ kojePolje, novi ],
			data: [ sredSt ],
			fail: function (error, textStatus, jqXHR, logicalError){				
			}
		});
	}
	
	function OsobaBySred(sred){
		return $.dsDirectCall({
			method: "OsobaBySred",
			params: [ sred ]
		});
	}
	
	function SobaByBarkod(barkod){
		return $.dsDirectCall({
			method: "SobaByBarkod",
			params: [ barkod ]
		});
	}
	
	function IKnjigaNabDefault(){
		return $.dsDirectCall({
			method: "IKnjigaNabDefault"
		});
	}
	
	function IRekapKnjDefault(){
		return $.dsDirectCall({
			method: "IRekapKnjDefault"
		});
	}
	
	function IAktDefault(){
		return $.dsDirectCall({
			method: "IAktDefault"
		});
	}
	
	function LokacijaById(lokacija){
		return $.dsDirectCall({
			method: "LokacijaById",
			params: [ lokacija ]
		});
	}

	function ZgradaById(lokacija, zgrada){
		return $.dsDirectCall({
			method: "ZgradaById",
			params: [ lokacija, zgrada ]
		});
	}
	
	function SobaById(lokacija, zgrada, soba){
		return $.dsDirectCall({
			method: "SobaById",
			params: [ lokacija, zgrada, soba ]
		});
	}

	function SobaByOznaka(lokacija, zgrada, oznaka){
		return $.dsDirectCall({
			method: "SobaByOznaka",
			params: [ lokacija, zgrada, oznaka ]
		});
	}	

	function TipPromById(tipprom){
		return $.dsDirectCall({
			method: "TipPromById",
			params: [ tipprom ]
		});
	}
	
	function TipPromObrisi(iTipProm){
		return $.dsDirectCallSync({
			method: "TipPromObrisi",
			params: [ iTipProm ]
		});
	}	
	
	function SredStZamijeniBrojStavke(sredSt1, sredSt2){
		return $.dsDirectCall({
			method: "SredStZamijeniBrojStavke",
			params: [ sredSt1, sredSt2 ]
		});
	}
	
	function SredStPreracunKartice(sred){
		return $.dsDirectCall({
			method: "SredStPreracunKartice",
			params: [ sred ]
		});
	}
	
	function SredStPresloziKarticu(sred){
		return $.dsDirectCall({
			method: "SredStPresloziKarticu",
			params: [ sred ]
		});
	}
	
	function SredStProvjeriIspisNaListi(sredSt){
		return $.dsDirectCall({
			method: "SredStProvjeriIspisNaListi",
			params: [ sredSt ]
		});
	}
	
	function SredStDodajUkloniSredStNaPopisnuListu(sredSt, dodaj){
		return $.dsDirectCall({
			method: "SredStDodajUkloniSredStNaPopisnuListu",
			params: [ sredSt, dodaj ]
		});
	}
	
	function SredStKarticaImaPreknjizenje(sred){
		return $.dsDirectCall({
			method: "SredStKarticaImaPreknjizenje",
			params: [ sred ]
		});
	}
	
	function SredStPromjenaKontaNaKartici(sred){
		return $.dsDirectCall({
			method: "SredStPromjenaKontaNaKartici",
			params: [ sred ]
		});
	}
	
	function SredStRekapPoKontu(sred, datum){		
		return $.dsDirectCall({
			method: "SredStRekapPoKontu",
			params: [ sred, datum ]
		});
	}
	
	function SredStPromjenaPozicijaIzvoriMogucUnosValidate(sredSt){		
		return $.dsDirectCall({
			method: "SredStPromjenaPozicijaIzvoriMogucUnosValidate",
			params: [ sredSt ]
		});
	}
	
	function SredStPreknjizenjePitanjePrijeUpisa(preknjizenje){			
		return $.dsDirectCall({
			method: "SredStPreknjizenjePitanjePrijeUpisa",
			params: [ preknjizenje ]
		});
	}
	
	function LokacijaObrisi(lokacija){
		return $.dsDirectCall({
			method: "LokacijaObrisi",
			params: [ lokacija ]
		});
	}
	
	function LokacijaMoguceBrisanje(lokacija){
		return $.dsDirectCall({
			method: "LokacijaMoguceBrisanje",
			params: [ lokacija ]
		});
	}
	
	function ZgradaSetAfterPolje(polje, zgrada, errorOverride){
        return $.dsDirectCallPost({
            method: "ZgradaSetAfterPolje",
            controller: "Zgrada",
			params: [ polje ],
            data: [ zgrada ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
    
	function ZgradaMoguceBrisanje(lokacija, zgrada){
		return $.dsDirectCallSync({
			method: "ZgradaMoguceBrisanje",
			params: [ lokacija, zgrada ]
		});
	}
	
	function ZgradaObrisi(lokacija, zgrada){
		return $.dsDirectCallSync({
			method: "ZgradaObrisi",
			params: [ lokacija, zgrada ]
		});
	}
	
	function SobaSetAfterPolje(polje, soba, errorOverride){
        return $.dsDirectCallPost({
            method: "SobaSetAfterPolje",
            controller: "Soba",
			params: [ polje ],
            data: [ soba ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
    
	function SobaMoguceBrisanje(lokacija, zgrada, soba){
		return $.dsDirectCallSync({
			method: "SobaMoguceBrisanje",
			params: [ lokacija, zgrada, soba ]
		});
	}
	
	function SobaObrisi(lokacija, zgrada, soba){
		return $.dsDirectCallSync({
			method: "SobaObrisi",
			params: [ lokacija, zgrada, soba ]
		});
	}
	
	function OsobaSetAfterPolje(polje, novi, osoba, errorOverride){
        return $.dsDirectCallPost({
            method: "OsobaSetAfterPolje",
            controller: "Osoba",
			params: [ polje, novi ],
            data: [ osoba ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
	
	function OsobaMoguceBrisanje(osoba){
		return $.dsDirectCallSync({
			method: "OsobaMoguceBrisanje",
			params: [ osoba ]
		});
	}
	
	function OsobaObrisi(osoba){
		return $.dsDirectCallSync({
			method: "OsobaObrisi",
			params: [ osoba ]
		});
	}
	
	function AmGrupaMoguceBrisanje(amGrupa){
		return $.dsDirectCallSync({
			method: "AmGrupaMoguceBrisanje",
			params: [ amGrupa ]
		});
	}
	
	function AmGrupaObrisi(amGrupa){
		return $.dsDirectCallSync({
			method: "AmGrupaObrisi",
			params: [ amGrupa ]
		});
	}
	
	function AmGrupaSetAfterPolje(polje, novi, obj, errorOverride){
        return $.dsDirectCallPost({
            method: "AmGrupaSetAfterPolje",
            controller: "AmGrupa",
			params: [ polje, novi ],
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
       
   	function AmGrupaPitanja(amGrupaS, amGrupaN, osSi){
		return $.dsDirectCallSync({
			method: "AmGrupaPitanja",
			params: [ amGrupaS, amGrupaN, osSi ]
		});
	}
	
	function AmGrupaPromSetAfterPolje(polje, amGrupaStara, amGrupaNova, osSi, obj, errorOverride){
        return $.dsDirectCallPost({
            method: "AmGrupaPromSetAfterPolje",
            controller: "AmGrupa",
			params: [ polje, amGrupaStara, amGrupaNova, osSi ],
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
	
	function OsGrupaMoguceBrisanje(osGrupa){
		return $.dsDirectCallSync({
			method: "OsGrupaMoguceBrisanje",
			params: [ osGrupa ]
		});
	}
	
	function OsGrupaObrisi(osGrupa){
		return $.dsDirectCallSync({
			method: "OsGrupaObrisi",
			params: [ osGrupa ]
		});
	}
	
	function OsKontoObrisi(osKonto){
		return $.dsDirectCall({
			method: "OsKontoObrisi",
			params: [osKonto],
		});
	}
		
	function GetAzuriranjeShemeKnjizenjaPitanja(osKonto){
		return $.dsDirectCall({
			method: "GetAzuriranjeShemeKnjizenjaPitanja",
		});
	}
	
	function AzuriranjeShemeKnjizenjaPremaStanjuNaKaricamaInventara(osKonto){
		return $.dsDirectCall({
			method: "AzuriranjeShemeKnjizenjaPremaStanjuNaKaricamaInventara",
		});
	}
	
	function GetAzurirajKarticuSvePitanje(){
		return $.dsDirectCall({
			method: "GetAzurirajKarticuSvePitanje",
		});
	}
	
	function GetAzurirajKarticuPitanje(osKonto){
		return $.dsDirectCall({
			method: "GetAzurirajKarticuPitanje",
			params: [osKonto]
		});
	}
	
	function OsKontoAzurirajKarticu(osKontoList){
		return $.dsDirectCall({
			method: "OsKontoAzurirajKarticu",
			params: [ osKontoList ]
		});	
	}
	
	function OsKontoAzurirajKarticuSve(filt){
		return $.dsDirectCall({
			method: "OsKOntoAzurirajKarticuSve",
			params: [ filt ]
		});	
	}

	function OsKontoNoviIzvoriVlasnistvaUpis(osKontoList, izvori){
		return $.dsDirectCall({
			method: "OsKontoNoviIzvoriVlasnistvaUpis",
			params: [ osKontoList, izvori ]
		});	
	}
	
	function OsZaduziSetAfterPolje(polje, obj, errorOverride){
        return $.dsDirectCallPost({
            method: "OsZaduziSetAfterPolje",
            controller: "OsZaduzi",
			params: [ polje ],
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }

	function OsOvlastenjeLoadListAfterInven(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "OsOvlastenjeLoadListAfterInven",
            controller: "OsOvlastenje",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
    
	function SBInvBrojClick(invBroj, ossi){
		return $.dsDirectCallSync({
			method: "SBInvBrojClick",
			params: [ invBroj, ossi ]
		});
	}
	
	function PonovoIzracunajBarKod(invBroj, osGrupa, ossi){
		return $.dsDirectCallSync({
			method: "PonovoIzracunajBarKod",
			params: [ invBroj, osGrupa, ossi ]
		});
	}	
	
	function SredSetAfterPolje(polje, novi, objects, errorOverride){
        return $.dsDirectCallPost({
            method: "SredSetAfterPolje",
            controller: "Sred",
			params: [ polje, novi ],
            data: [ objects ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }

	function SredSkObrisi(sredSk, osSi){
		return $.dsDirectCallSync({
			method: "SredSkObrisi",
			params: [ sredSk, osSi ]
		});
	}

	function SredSetParamOsnovniPodaci(prikaziOsnovnePodatke, prikaziSadasnjuVrijednost){
		return $.dsDirectCallSync({
			method: "SredSetParamOsnovniPodaci",
			params: [ prikaziOsnovnePodatke, prikaziSadasnjuVrijednost ]
		});
	}	
	
	function OsOvlastenjeDeaktiviraj(listaOvlastenja, errorOverride){
        return $.dsDirectCall({
            method: "OsOvlastenjeDeaktiviraj",
			params: [ listaOvlastenja ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function AmortizacijaUpisi(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "AmortizacijaUpisi",
            controller: "Amortizacija",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function AmortizacijaSetAfterPolje(polje, obj, errorOverride){
        return $.dsDirectCallPost({
            method: "AmortizacijaSetAfterPolje",
            controller: "Amortizacija",
			params: [ polje ],
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
    
	function AmortizacijaObrisi(datum, ossi, upozadini, errorOverride){
        return $.dsDirectCall({
            method: "AmortizacijaObrisi",
			params: [ datum, ossi, upozadini ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function BrojDokumentaGKZadnji(dokum){
		return $.dsDirectCallSync({
			method: "BrojDokumentaGKZadnji",
			params: [ dokum ]
		});
	}
	
	function Revaloriziraj(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "revaloSubmit",
            controller: "Revalo",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
    	
	function RashodUpisi(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "RashodUpisi",
            controller: "Rashod",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function RashodSetAfterPolje(polje, obj, errorOverride){
        return $.dsDirectCallPost({
            method: "RashodSetAfterPolje",
            controller: "Rashod",
			params: [ polje ],
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function RashodValidatePolje(rashod, kojePolje, novi){		
		return $.dsDirectCallPost({
			method: "RashodValidatePolje",
			controller: "rashod",
			params: [ kojePolje, novi ],
			data: [ rashod ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
		});
	}	

	function RazduziZaduziSetAfterPolje(polje, obj, errorOverride){
        return $.dsDirectCallPost({
            method: "RazduziZaduziSetAfterPolje",
            controller: "RazduziZaduzi",
			params: [ polje ],
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function ArhivaZakljucaj(godina, opcije){
		return $.dsDirectCallSync({
			method: "ArhivaZakljucaj",
			params: [ godina, opcije ]
		});
	}
	
	function ArhivaOtkljucaj(godina, opcije){
		return $.dsDirectCallSync({
			method: "ArhivaOtkljucaj",
			params: [ godina, opcije ]
		});
	}
	
	function ArhivaObrisi(godina){
		return $.dsDirectCallSync({
			method: "ArhivaObrisi",
			params: [ godina ]
		});
	}	

	function SredSlikaGetSlika(sred, slika){
		return $.dsDirectCallSync({
			method: "SredSlikaGetSlika",
			params: [ sred, slika ]
		});
	}	
	
	function SredSlikaUpload(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "SredSlikaSubmit",
            controller: "SredSlika",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }		

	function SredSlikaCopy(sred, slika){
		return $.dsDirectCallSync({
			method: "SredSlikaCopy",
			params: [ sred, slika ]
		});
	}

	function SredSlikaPaste(sred){
		return $.dsDirectCallSync({
			method: "SredSlikaPaste",
			params: [ sred ]
		});
	}	

	function SredSlikaObrisi(sred, slika){
		return $.dsDirectCallSync({
			method: "SredSlikaObrisi",
			params: [ sred, slika ]
		});
	}	

	function SredSlikaRename(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "SredSlikaRename",
            controller: "SredSlika",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }		

	function NapuniVrstePromjene(osSi){
		return $.dsDirectCallSync({
			method: "NapuniVrstePromjene",
			params: [ osSi ]
		});
	}	

	function ProvjeriDokumentZaKnjizenje(vrstaDok, brojDok){
		return $.dsDirectCallSync({
			method: "ProvjeriDokumentZaKnjizenje",
			params: [ vrstaDok, brojDok ]
		});
	}	
	
	function CBVrPromjeneChange(itemIndex){
		return $.dsDirectCall({
			method: "CBVrPromjeneChange",
			params: [ itemIndex ]
		});
	}		

	function GetOsZaduziMogucIspravak(osZaduzi){
		return $.dsDirectCall({
			method: "GetOsZaduziMogucIspravak",
			params: [ osZaduzi ]
		});
	}			

	function SredKopirajViseSetBarkodAfterInvBroj(invBroj, ossi){
		return $.dsDirectCall({
			method: "SredKopirajViseSetBarkodAfterInvBroj",
			params: [ invBroj, ossi ]
		});
	}	

	function PostavkeMogucUnos(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "PostavkeMogucUnos",
            controller: "Postavke",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }		

	function PostavkeProvjeriInventuru(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "PostavkeProvjeriInventuru",
            controller: "Postavke",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function PostavkeSetAfterPolje(polje, podesiInventuru, postavke, errorOverride){
        return $.dsDirectCallPost({
            method: "PostavkeSetAfterPolje",
            controller: "postavke",
			params: [ polje, podesiInventuru ],
            data: [ postavke ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function OsGrupaShemaObrisi(osgrupa, godina, izvori, oskonto){
		return $.dsDirectCall({
			method: "OsGrupaShemaObrisi",
			params: [ osgrupa, godina, izvori, oskonto ]
		});
	}	

	function OsGrupaShemaDefinirana(izvori, oskonto){
		return $.dsDirectCall({
			method: "OsGrupaShemaDefinirana",
			params: [ izvori, oskonto ]
		});
	}		

	function OsGrupaShemaSeMijenja(izvori, oskonto, osgrupa, amgrupa){
		return $.dsDirectCall({
			method: "OsGrupaShemaSeMijenja",
			params: [ izvori, oskonto, osgrupa, amgrupa ]
		});
	}		

	function OsGrupaGetAgPromjena(osgrupa){
		return $.dsDirectCall({
			method: "OsGrupaGetAgPromjena",
			params: [ osgrupa ]
		});
	}		

	function OsGrupaUpisAmGrupeUSredstva(osgrupa){
		return $.dsDirectCall({
			method: "OsGrupaUpisAmGrupeUSredstva",
			params: [ osgrupa ]
		});
	}		

    function GetZaduzenjaInventaraSFields() {
        return $.dsDirectCall({ 
			method: "GetZaduzenjaInventaraSFields"
        });
    }	

	function InventarObrisi(invBrojArray){
		return $.dsDirectCall({
			method: "InventarObrisi",
			params: [ invBrojArray ]
		});
	}		

	function InventarImportXml(inventarImportXml, errorOverride){
		return $.dsDirectCallPost({
			method: "InventarImportXmlSubmit",
			controller: "Inventar",
			params: [  ],
			data: [ inventarImportXml ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }					
		});			
	}	

	function InvenTrebaLiUskladitiKolSaKarticom(inven, doDana){
		return $.dsDirectCall({
			method: "InvenTrebaLiUskladitiKolSaKarticom",
			params: [ inven, doDana ]
		});
	}		

	function InvenUskladiKolSaKarticom(inven, osSi, doDana){
		return $.dsDirectCall({
			method: "InvenUskladiKolSaKarticom",
			params: [ inven, osSi, doDana ]
		});
	}			

	function SredMogucaPodjelaKartice(sredId, dNabave){
		return $.dsDirectCall({
			method: "SredMogucaPodjelaKartice",
			params: [ sredId, dNabave ]
		});
	}	

	function SredGetPitanjeZaPodjeluKartice(sredId, dNabave, invBroj){
		return $.dsDirectCall({
			method: "SredGetPitanjeZaPodjeluKartice",
			params: [ sredId, dNabave, invBroj ]
		});
	}		

	function SredPodijeliKarticu(sredId, dNabave, invBroj){
		return $.dsDirectCall({
			method: "SredPodijeliKarticu",
			params: [ sredId, dNabave, invBroj ]
		});
	}

	function SredUmetniInventurneBrojeve(osSi, pomak, invBroj){
		return $.dsDirectCall({
			method: "SredUmetniInventurneBrojeve",
			params: [ osSi, pomak, invBroj ]
		});
	}	
	
    function GetSobaZaduziFields() {
        return $.dsDirectCall({ 
			method: "GetSobaZaduziFields" 
        });
    }	

	function SredOpGetBrojSlika(sredId){
		return $.dsDirectCall({
			method: "SredOpGetBrojSlika",
			params: [ sredId ]
		});
	}		

} (konto.os.api = {}));